import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemCategory\UpdateMultipleItemCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/UpdateMultipleItemCategoryController.php
* @route '/api/item-category/multiple-item-update'
*/
const UpdateMultipleItemCategoryController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UpdateMultipleItemCategoryController.url(options),
    method: 'post',
})

UpdateMultipleItemCategoryController.definition = {
    methods: ["post"],
    url: '/api/item-category/multiple-item-update',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ItemCategory\UpdateMultipleItemCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/UpdateMultipleItemCategoryController.php
* @route '/api/item-category/multiple-item-update'
*/
UpdateMultipleItemCategoryController.url = (options?: RouteQueryOptions) => {
    return UpdateMultipleItemCategoryController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemCategory\UpdateMultipleItemCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/UpdateMultipleItemCategoryController.php
* @route '/api/item-category/multiple-item-update'
*/
UpdateMultipleItemCategoryController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UpdateMultipleItemCategoryController.url(options),
    method: 'post',
})

export default UpdateMultipleItemCategoryController